<div id="sharingModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" class="modal full-modal fade"
>
	<div class="modal-dialog"  style="max-width: 100%;">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" (click)="closePanel()" aria-label="Close" class="close"style="margin-right: 0%;margin-top: 0%;">
					<span aria-hidden="true"></span>
				</button>
				<div class="modal-container">
					<div class="row">
						<div class="col-sm-8">
							<h4 id="myModalLabel" *ngIf="!data.hasOwnProperty('setting')" class="modal-title">{{bs.getResource('rbkey_ShrngPnlLBL')}}</h4>
							<h4 id="myModalLabel" *ngIf="data.hasOwnProperty('setting')" class="modal-title">{{bs.getResource('rbkey_UsrHdgPnlLBL')}}</h4>
							
						</div>
					</div>
				</div>
			</div>
			<div class="main-section overview-timeline overview-timeline-share">
				<section class="">
					<div class="content-wrapper no-padding animated-half slideTop">
						<div class="overview-block">
							<div class="overview-left overview-left1">
								<div class="drop-box-left drop-box-left1">
								
									<div class="calendar-drop overlay-hide ">
											<div class="calendar-right-header">
												<div class="crh-left">{{bs.getResource('rbkey_MpUsrsLBL')}}</div>
											</div>
											<div class="cr-inner cr-inner-bottom">
	
												<div class="cr-in-box">
													<div class="cr-inn-top">
														<app-user-list [parentName]="constructorName"></app-user-list>
													</div>
													<div class="cr-inn-bottom" *ngIf="!data.hasOwnProperty('setting')">
														<div *ngIf="isActiveMessageBox">
															<div id="rtfBox">
																<quill-editor (onContentChanged)="editorContentChanged($event)" [placeholder]="bs.getResource('rbkey_ShrArPlcHldrLBL')" [modules]="editorConfig"></quill-editor>
															</div>
															<br>
															<div *ngIf="isActiveFileUpload">				
															<app-file-upload [fileUploadParam]="{AllowedFileTypes:'IMAGE', FileLabel:'rbkey_UpldTlImgFlLBL',id:'1'}"></app-file-upload><br>
															<file-upload-attachement [fileUploadParamAttachement]="{AllowedFileTypes:'DOCUMENT|IMAGE|ZIP|VIDEO|AUDIO', FileLabel:'rbkey_UpldAttchmntFlLBL',id:'1'}"></file-upload-attachement><br>
															</div>
														</div>
														<a class="share-btn" href="javascript:void(0);" (click)="ShareData()">{{bs.getResource('rbkey_ShrLBL')}}</a>
													</div>
													<div class="cr-inn-bottom" *ngIf="data.hasOwnProperty('setting')">
														<a class="share-btn" style="margin-left: 10px" href="javascript:void(0);" (click)="backToHideUserList()">{{bs.getResource('rbkey_BckTStngLstLBL')}}</a>
														<a class="share-btn" href="javascript:void(0);" (click)="saveHideUserList()">{{bs.getResource('rbkey_HdLBL')}}</a>
													</div>
												</div>
											</div>
	
	
										</div>
								</div>
							</div>
							<div class="overview-right overview-right1">
								<div class="drop-box-right drop-box-right1">
										<div class="leaderboard-drop overlay-hide ">
												<div class="leaderboard-heading">
													<div class="leaderboard-title">{{bs.getResource('rbkey_VsbltFltrLBL')}}</div>
												</div>
												<div class="leaderboard-drop-inner leaderboard-drop-inner1">
													<div role="tabpanel" class="custom-tabpanel">
														<div class="tab-content">
															<div id="courses" role="tabpanel" class="tab-pane fade show active">
																<div class="leaderboard-tab-inner leaderboard-tab-inner1">
																	<app-visibility-filter></app-visibility-filter>
																</div>
															</div>
														</div>
													</div> 
												</div>
		
											</div>

								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>